export const templateSubSectionNavMixin = {
  computed: {
    subSectionNav() {
      if(!this.$route.params.id) return null;
      return [
        { to: { name: 'admin_communication_template_edit', params: { id: this.$route.params.id } }, label: 'Edit' },
        { to: { name: 'admin_communication_template_edit_advanced', params: { id: this.$route.params.id } }, label: 'Advanced' },
      ]
    }
  }
}
